import React from 'react';
import { Button, Modal, Message } from 'semantic-ui-react';

// Confirmation shown before removing point(s) from a component (single-row delete
// OR a modal unassign). dependentCount is how many existing equipment currently use
// the point(s) — shown as INFORMATION only. Removal does NOT affect existing equipment
// (there is no cascade in the current DB); it only stops NEW equipment built from this
// component from inheriting the point.
export const PointDeleteConfirmation = ({
    open,
    setOpen,
    submitAction,
    loading,
    dependentCount = 0,
    title = 'Are you sure you want to remove this point?',
    confirmLabel = 'Remove',
    description,
}) => {
    return (
        <Modal open={open} onClose={() => !loading && setOpen(false)} size="tiny">
            <Modal.Header>{title}</Modal.Header>
            <Modal.Content>
                {description ? (
                    description
                ) : dependentCount > 0 ? (
                    <Message info data-testid="dependents-info">
                        <Message.Header>Existing equipment is not affected</Message.Header>
                        <p>
                            {dependentCount} existing piece{dependentCount === 1 ? '' : 's'} of
                            equipment use{dependentCount === 1 ? 's' : ''} this point — they keep
                            their copy and are unchanged. New equipment built from this component
                            will no longer include it.
                        </p>
                    </Message>
                ) : (
                    <p>New equipment built from this component will no longer include this point.</p>
                )}
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => setOpen(false)} disabled={loading} data-testid="delete-cancel">
                    Cancel
                </Button>
                <Button
                    className="ui primary button"
                    onClick={submitAction}
                    loading={loading}
                    disabled={loading}
                    data-testid="delete-confirm"
                >
                    {confirmLabel}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};
